module.exports = __webpack_public_path__ + "img/handle.3e19d36a.svg";